module.exports = __webpack_public_path__ + "static/img/Letournel_Judet_classification_of_acetabular_fractures_img1.ed5b205.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/Letournel_Judet_classification_of_acetabular_fractures_img1.png
// module id = /nTr
// module chunks = 2